import { useNavigate } from "react-router-dom"
import { useAppSelector } from "../../../stateManagement/hooks/redux"
import { Button } from "primereact/button";
import NoFederalRoadsMessage from "./NoFederalRoadsMessage";

export default function FederalRoadsInfo() {
    const navigate = useNavigate();
    const federalRoadFeatures = useAppSelector(state => state.objectsOnMapPointInfo.federalRoadFeatures)

    return (
        <div className="federal-roads-info-div">
            <strong>Автомобильные дороги общего пользования федерального значения:</strong>
            <div>
                {federalRoadFeatures.map((feature: any) => {
                    const [, id] = feature.id.split('.')
                    return (
                        <Button severity="info" text raised onClick={() => navigate(`/app/osmFederalRoad/${id}`)}>
                            {feature.properties.PATHNAME}
                        </Button>
                    )
                })}
                {federalRoadFeatures.length === 0 && <NoFederalRoadsMessage />}
            </div>
        </div>
    )
}
